export default __webpack_public_path__ + "static/media/sportprevent.ab679226.jpg";